import React from "react";
import Link from "../../Link/Link";
import styles from "./LinksCard.module.sass";
import { useGlobalValue } from "../../../state/GlobalProvider";
import { hydrateRoute } from "../../../utils";
import Icon from "../../Icon/Icon";
const LinksCard = props => {
  const {
    title,
    items
  } = props || {};
  const {
    params
  } = useGlobalValue();
  const list = (items || []).filter(({
    count
  }) => count !== undefined).map((item, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles["list-item"]
    }, /*#__PURE__*/React.createElement("h5", null, item.link ? /*#__PURE__*/React.createElement(Link, {
      to: hydrateRoute(item.link, params),
      label: item.name
    }) : item.name), /*#__PURE__*/React.createElement("small", null, item.count));
  });
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles['root']} links-card-to-include`
  }, /*#__PURE__*/React.createElement("div", {
    className: `widget-title ${styles["title-container"]}`
  }, /*#__PURE__*/React.createElement(Icon, {
    className: styles["icon"],
    name: "dashboard-top"
  }), /*#__PURE__*/React.createElement("h5", {
    className: styles['title']
  }, title)), /*#__PURE__*/React.createElement("div", null, list));
};
export default LinksCard;